
















































































































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';

import { Button, Form, FormItem, Option, Select } from 'element-ui';
import NullableInput from '@/components/element-ui/NullableInput.vue';
import ContactUpsert from '@/components/modals/ContactUpsert.vue';

import countries from '@/mixins/countryOptions';
import contacts from '@/mixins/contactOptions.ts';

import {
  ContactFields,
  ContactInput,
  CustomerOrganizationFields,
  NaccsContactFields
} from '@/types/graphql/schemaTypes';

import get from 'lodash/get';
import { customerOrganizationService } from '../../services/CustomerOrganizationService';

@Component({
  components: {
    ContactUpsert,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': NullableInput,
    'el-option': Option,
    'el-select': Select
  }
})
export default class NaccsContact extends Mixins(contacts, countries) {
  @Prop({ type: Object }) contact?: ContactInput;
  @Prop({ default: () => ({}) }) customerOrganization!: CustomerOrganizationFields;
  @Prop({ type: Boolean, default: false }) editing!: boolean;
  @Prop({ type: Boolean, default: false }) isCustomer!: boolean;

  private contactInput: ContactInput | null = null;
  private contacts: NaccsContactFields[] = [];
  private selectedContact: NaccsContactFields | null = null;
  private loading = false;
  private showModal = false;

  created() {
    // force default language for country select
    this.lang = 'en';
    this.setInput(this.contact);
  }

  private handleClear() {
    this.selectedContact = null;
    this.setDefaultInput();
    this.$emit('updateContact', null);
  }

  // handle contact selection to trigger creation
  private handleSelect(contact: NaccsContactFields | 'new') {
    this.$emit('edited');
    if (contact === 'new') {
      this.showModal = true;
    } else {
      this.setInput(contact);
    }
  }

  private formatSublabel(contact: NaccsContactFields) {
    if (!contact.address) {
      return;
    }

    const subLabel = [
      contact.address.postalCode,
      contact.address.prefecture,
      contact.address.city
    ];

    return subLabel.filter((label: string | null) => {
      return label !== null;
    }).join(', ');
  }

  private setContact(contact: ContactFields) {
    this.setInput(contact);
    this.$apollo.queries.contactOptions.refetch(); // refresh contact list
  }

  private setDefaultInput() {
    this.contactInput = {
      address: {
        city: null,
        countryCode: null,
        line1: null,
        line2: null,
        prefecture: null,
        postalCode: null
      },
      name: null,
      normalizedName: null,
      phoneNumber: null
    };
  }

  private setInput(contact?: NaccsContactFields | ContactInput) {
    if (!contact) {
      this.setDefaultInput();
      return;
    }

    this.contactInput = {
      address: {
        city: get(contact, 'address.city', null),
        countryCode:
          get(contact, 'address.countryCode', null) || // if from ida
          get(contact, 'country.unLocode', null), // if from contact selection
        line1: get(contact, 'address.line1', null),
        line2: get(contact, 'address.line2', null),
        postalCode: get(contact, 'address.postalCode', null),
        prefecture: get(contact, 'address.prefecture', null)
      },
      name: contact.name || '',
      normalizedName: contact.normalizedName || null,
      phoneNumber: contact.phoneNumber || null
    };
  }

  private async updateCustomerOrganization() {
    if (!this.contactInput) {
      return;
    }

    try {
      const response = await customerOrganizationService.updateCustomerOrganization(
        {
          address: {
            city: get(this.contactInput, 'address.city', null),
            line1: get(this.contactInput, 'address.line1', null),
            line2: get(this.contactInput, 'address.line2', null),
            prefecture: get(this.contactInput, 'address.prefecture', null)
          },
          countryCode: get(this.contactInput, 'address.countryCode', null),
          id: this.customerOrganization.id,
          normalizedName: this.contactInput.normalizedName,
          phoneNumber: this.contactInput.phoneNumber,
          postalCode: get(this.contactInput, 'address.postalCode', null)
        }
      );

      if (response.data) {
        this.emitData();
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (e) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.loading = false;
    }
  }

  @Watch('contactInput', { deep: true })
  private emitData() {
    this.$emit('updateContact', this.contactInput);
  }

  @Watch('editing')
  private setEdition() {
    this.setInput(this.contact);
  }

  @Watch('isCustomer')
  private setShipperIsCustomer(isCustomer: boolean) {
    if (isCustomer) {
      // format shipper into contact object
      this.contactInput = {
        address: {
          city: get(this.customerOrganization, 'address.city', null),
          countryCode: get(this.customerOrganization, 'countryCode', null),
          line1: get(this.customerOrganization, 'address.line1', null),
          line2: get(this.customerOrganization, 'address.line2', null),
          postalCode: get(this.customerOrganization, 'postalCode', null),
          prefecture: get(this.customerOrganization, 'address.prefecture', null)
        },
        name: this.customerOrganization.name || '',
        normalizedName:
          this.customerOrganization.normalizedName ||
          this.customerOrganization.name,
        phoneNumber: this.customerOrganization.phoneNumber || null
      };
    }
  }
}
